import React from 'react';
import { skillCategories } from '../data/projectsData';

function ChipRow({ core = [], familiar = [] }) {
  return (
    <div className="flex flex-wrap gap-2">
      {core.map((skill) => (
        <span key={skill} className="tag tag-core">{skill}</span>
      ))}
      {familiar.map((skill) => (
        <span key={skill} className="tag">{skill}</span>
      ))}
    </div>
  );
}

export default function Skills() {
  const groups = skillCategories.filter((category) => !category.muted);
  const exploring = skillCategories.find((category) => category.muted);

  return (
    <section id="skills" className="py-[clamp(48px,9vw,84px)]" aria-labelledby="skills-heading">
      <h2
        id="skills-heading"
        className="mb-2 block font-extrabold uppercase tracking-[-0.01em] text-[32px] text-[#FBF0DC]/80"
      >
        Skills
      </h2>
      <div className="border-t-2 border-[#FBF0DC]/35 pt-7">
        <p className="mb-7 text-[12px] text-[#FBF0DC]/50">Filled = core · outline = familiar</p>

        <div className="grid gap-x-10 gap-y-7 [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
          {groups.map((category) => (
            <div key={category.title}>
              <h3 className="m-0 mb-3 text-lg font-extrabold">{category.title}</h3>
              <ChipRow core={category.core} familiar={category.familiar} />
            </div>
          ))}
        </div>
      </div>

      {exploring && (
        <div className="mt-10 border-t-2 border-[#FBF0DC]/35 pt-7">
          <h3 className="m-0 mb-3 text-[13px] font-normal uppercase tracking-[0.08em] text-[#FBF0DC]/50">
            {exploring.title}
          </h3>
          <ChipRow familiar={exploring.familiar} />
        </div>
      )}
    </section>
  );
}
